<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Productos vendidos</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card>
            <v-container fluid>
              <v-row>
                <v-col cols="2">
                  <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.from"
                        label="Desde"
                        readonly
                        clearable
                        v-on="on"
                        outlined
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.from"
                      @input="menuFrom = false"
                      no-title
                      locale="es"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    v-model="menuUntil"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.until"
                        label="Hasta"
                        readonly
                        clearable
                        v-on="on"
                        outlined
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.until"
                      @input="menuUntil = false"
                      no-title
                      locale="es"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    ref="product_id"
                    v-model="filters.product_id"
                    :items="productsList"
                    label="Producto"
                    outlined
                    item-text="description"
                    item-value="id"
                    clearable
                    :value="filters.product_id"
                    :loading="isLoading"
                    hide-details="auto"
                    placeholder="Ingrese el producto a buscar"
                    required
                  ></v-autocomplete>
                  <!-- <v-autocomplete
                    v-model="filters.product_id"
                    :items="products_api"
                    label="Producto"
                    outlined
                    item-text="description"
                    item-value="product_id"
                    clearable
                    hide-details="auto"
                    :loading="isLoading"
                    :search-input.sync="search_product"
                    hide-no-data
                    hide-selected
                    placeholder="Ingrese el producto a buscar"
                  ></v-autocomplete> -->
                </v-col>
                <v-col cols="4">
                  <v-btn color="blue" dark @click="searchProducts">
                    Buscar
                  </v-btn>
                  <v-btn
                    color="green"
                    dark
                    class="ml-2"
                    :loading="processing"
                    @click="downloadProducts"
                  >
                    Descargar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="products"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              fixed-header
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                  >Todas los productos vendidos</span
                >
                <v-divider></v-divider>
              </template>

              <template v-slot:item.sale_date="{ item }">
                <span>{{ item.sale_date | moment("DD/MM/YYYY") }}</span>
              </template>

              <template v-slot:item.subtotal="{ item }">
                <span>{{ item.subtotal | currency("S/") }}</span>
              </template>

              <template v-slot:item.discount_value="{ item }">
                <span>{{ item.discount_value | currency("S/") }}</span>
              </template>

              <template v-slot:item.total="{ item }">
                <span>{{
                  (item.subtotal - item.discount_value) | currency("S/")
                }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import InventoryApi from "../../../apis/Inventories";

export default {
  name: "SoldProducts",
  components: {
    OfficeLogin,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "FECHA", value: "sale_date", sortable: false },
        { text: "PRODUCTO", value: "description", sortable: false },
        { text: "CANTIDAD", value: "quantity", sortable: false },
        { text: "SUBTOTAL", value: "subtotal", sortable: false },
        { text: "DESCUENTO", value: "discount_value", sortable: false },
        { text: "TOTAL", value: "total", sortable: false },
      ],
      processing: false,
      menuFrom: false,
      menuUntil: false,
      filters: {
        type_item: "product",
        from: this.$moment().format("YYYY-MM-DD"),
        until: this.$moment().format("YYYY-MM-DD"),
        product_id: null,
      },
      isLoading: false,
      search_product: null,
      products_api: [],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
      productsList: [],
    };
  },
  computed: {
    ...mapState("report-products", ["products", "file_name", "paginated"]),
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getSoldProducts({
          ...this.filters,
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("report-products", [
      "getSoldProducts",
      "setProducts",
      "downloadSoldProducts",
    ]),
    searchProducts() {
      this.getSoldProducts(this.filters);
    },
    async downloadProducts() {
      this.processing = true;
      let filters_data = Object.assign({}, this.filters);
      await this.downloadSoldProducts(filters_data);
      this.processing = false;
      if (this.file_name) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_name;
        window.open(url);
      }
    },
    // async searchProducts(event) {
    //   this.isLoading = true;
    //   const value = event.target.value;
    //   if (value.length > 0) {
    //     await this.getSuppliers({ name: value });
    //   } else {
    //     await this.getSuppliers();
    //   }
    //   this.isLoading = false;
    // },
    async searchProductsInventories() {
      const response = await InventoryApi.getProductsFromOffice({});
      if (response.status == 200) {
        this.productsList = response.data;
      }
    },
  },
  created() {
    // this.searchProducts();
    this.searchProductsInventories();
  },
  destroyed() {
    this.setProducts([]);
  },
};
</script>

<style scoped></style>
